export default "__VITE_ASSET__6571ced9__"